import React, { Component } from 'react';
import _ from 'lodash';

import { MoreVert as MoreVertIcon } from '@material-ui/icons';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Menu,
	MenuItem,
	Typography
} from '@material-ui/core';


import { MyPATPopMenu, MenuData } from '../../../common';


const styles = createStyles({
	root: {

	}
});

//@ts-ignore
interface ContentMoreMenuProps extends WithStyles<typeof styles> {
	classes: any,
	clicked?: Function
}
interface ContentMoreMenuState {
	moreAnchorEl: any
}

class ContentMoreMenu extends Component<ContentMoreMenuProps, ContentMoreMenuState>{
	menuItems: MenuData[] = [{
		type: 'callback',
		id: 1,
		to: "",
		img: "/assets/img/mylibrary/settingsMenu/share-option-icon.png",
		text: "Share"
	},{
		type: 'callback',
		id: 2,
		to: "",
		img: "/assets/img/mylibrary/big-speech-balloon.png",
		text: "Comment"
	},{
		type: 'callback',
		id: 3,
		to: "",
		img: "/assets/img/course/copy.png",
		text: "Copy Course"
	},
	{
		type: 'callback',
		id: 4,
		to: "",
		img: "/assets/img/course/copy.png",
		text: "Archive Course"
	}
	];

	constructor(props: ContentMoreMenuProps, state: ContentMoreMenuState) {
		super(props);

		this.clicked = this.clicked.bind(this);
	}

	clicked(item: any) {
		if (this.props.clicked) {
			this.props.clicked(item.text);
		}
	}

	render() {
		let menuI: MenuData[] = this.menuItems;
		return (<MyPATPopMenu id="content-more-menu" icon={MoreVertIcon} menuItem={menuI} clicked={this.clicked} />
		);
	}
}

// @ts-ignore
export default withStyles(styles)(ContentMoreMenu);